const header = $('#header');

$(window).on('load', () => {
	
	$( ".nextButton" ).click(function() {
		var prev = $(this).parent().parent().index()
		var next = prev + 1
		$("#fortschrittsBalken div span").removeClass("active")
		$("#fortschrittsBalken div span").eq(next).addClass("active")
		changeSteps(prev, next);
	});

	$(".emoji").mouseenter(function() {
		var et = $(this).attr("et")
		$(".emojisText").text(et)
	});

	$(".emoji").mouseleave(function() {
		$(".emojisText").text("")
	});

	$( ".guestionContainer li, .nextQ" ).click(function() {
		var section = $(this).parent().parent().parent().parent()
		var sectionIndex = $(section).index()
		var index = $(this).parent().parent().index()
		var questionCount = $(section).find('.guestionContainer').length
		if(sectionIndex === 2) {
			if (index === 0) {
				user.zukunftsAusblick = $(this).attr("val")
			}
			if (index === 1) {
				user.zukunftMuenchen = $(this).attr("val")
			}
			if (index === 2) {
				user.akteure.unternehmen = $("#akteure_unternehmen").val()
				user.akteure.wissenschaft = $("#akteure_wissenschaft").val()
				user.akteure.politik = $("#akteure_politik").val()
				user.akteure.ngos = $("#akteure_ngos").val()
				user.akteure.einzelne = $("#akteure_einzelne").val()
			}
			if (index === 3) {
				user.einfluss = $("#antwort_einfluss .active").text()
				if( user.einfluss === "Ja" ) {
					user.einflussText = $("#freitext_einfluss").val()
				}
				if( user.einfluss === "Nein" ) {
					user.einflussText = $("#freitext_keinEinfluss").val()
				}
			}
			if (index === 4) {
				user.geschlecht = $("#antwort_geschlecht .active").text()
				user.alter = $("#antwort_alter .active").text()
				user.wohnort = $("#antwort_wohnort .active").text()
			}
		}
		if(sectionIndex === 7) {
			if (index === 0) {
				artefakt.stimmung = $("#art_wirkung .active").attr("et")
			}
			if (index === 1) {
				artefakt.lebenswert = $(this).attr("val")
				console.log(artefakt.lebenswert)
			}
			if (index === 2) {
				artefakt.nutzung = $(this).attr("val")
			}
			if (index === 3) {
				artefakt.beeinflussen_wert = $("#art_impact").val()
			}
			if (index === 4) {
				artefakt.beeinflussen = $("#art_einfluss .active").text()
				if( artefakt.beeinflussen === "Ja" ) {
					artefakt.beeinflussen_text = $("#art_freitext_einfluss").val()
				}
				if( artefakt.beeinflussen === "Nein" ) {
					artefakt.beeinflussen_text = $("#art_freitext_keinEinfluss").val()
				}
			}
			if (index === 5) {
				artefakt.sharing = $("#art_share .active").text()
				artefakt.sharing_text = $( ".guestionContainer h5.active" ).text()
			}
			if (index === 6) {
				artefakt.botschaft = $("#art_message").val()
			}
		}
		if( index === (questionCount - 1)) {	
			changeSteps(sectionIndex, sectionIndex + 1);
			$(this).parent().parent().parent().find( ".guestionContainer" ).removeClass("active")
			$(this).parent().parent().parent().find('.guestionContainer').eq(0).addClass("active")
			$("#fortschrittsBalken div span").removeClass("active")
			$("#fortschrittsBalken div span").eq(sectionIndex + 1).addClass("active")
		} else {
			$(this).parent().parent().parent().find( ".guestionContainer" ).removeClass("active")
			$(this).parent().parent().parent().find('.guestionContainer').eq(index + 1).addClass("active")
		}
	});

	$( ".lastQ" ).click(function() {
		var index = $(this).parent().index()
		$(this).parent().parent().find( ".guestionContainer" ).removeClass("active")
		$(this).parent().parent().find('.guestionContainer').eq(index - 1).addClass("active")
	})

	$( ".guestionContainer h5" ).click(function() {
		if ( $(this).hasClass("active") === true) {
			$(this).removeClass("active")
		} else {
			$(".guestionContainer h5").removeClass("active")
			$(this).addClass("active")
		}
	});

	$( ".setAudioNO" ).click(function() {
		$("#fortschrittsBalken div span").removeClass("active")
		$("#fortschrittsBalken div span").eq(1).addClass("active")
		$('.container').addClass("noAudio")
		$("#artefakte").addClass("visible")
		$("#vorsatzContainer").addClass("visible")
		$("#finalContainer").addClass("visible")
		$(".audioContainerOverlay").addClass("visible")
		$(".nextButton").prop("disabled", false)
		$("#vorsatzFassen").prop("disabled", false)
		changeSteps(0, 1)
	});

	$( ".setAudioYES" ).click(function() {
		$("#fortschrittsBalken div span").removeClass("active")
		$("#fortschrittsBalken div span").eq(1).addClass("active")
		changeSteps(0, 1)
	})

	$( ".guestionContainer .btn-group button" ).click(function() {
		$(this).parent().find( "button" ).removeClass("active")
		$(this).addClass("active")
	})

	$( ".guestionContainer .btn-group.variables button" ).click(function() {
		var index = $(this).index()
		$('.variableContainer div').removeClass("active")
		$(this).parent().parent().find(".variableContainer div").eq(index).addClass("active")	
	})

	$( "#backToStart" ).click(function() {
		changeSteps(3, 0)
		$("#fortschrittsBalken div span").removeClass("active")
		$("#fortschrittsBalken div span").eq(0).addClass("active")
	})

	$( "#artefakte div" ).click(function() {
		var aid = $(this).index() + 1
		if (aid === 1) {
			$("#pdfLink").attr("href", "/assets/pdfs/01-bilde-dich-selbst–und-ermoegliche-bildung-fuer-andere.pdf")
		}
		if (aid === 2) {
			$("#pdfLink").attr("href", "/assets/pdfs/02-entstresskultur-mitgestalten.pdf")
		}
		if (aid === 3) {
			$("#pdfLink").attr("href", "/assets/pdfs/03-stadtgestaltung-in-deiner-hand.pdf")
		}
		if (aid === 4) {
			$("#pdfLink").attr("href", "/assets/pdfs/04-auch-in-zukunft-sinnvoll-reisen.pdf")
		}
		if (aid === 5) {
			$("#pdfLink").attr("href", "/assets/pdfs/05-schaffe-naehe–schaffe-menschlichkeit.pdf")
		}
		if (aid === 6) {
			$("#pdfLink").attr("href", "/assets/pdfs/06-global-denken–alle-gehoeren-dazu.pdf")
		}
		$("#fortschrittsBalken div span").removeClass("active")
		$("#fortschrittsBalken div span").eq(4).addClass("active")
		changeSteps(3, 4, aid)
		$('.container').attr('ca', aid)
		if( $(".container").hasClass("noAudio") === false ) {
			$('#step4 .nextButton').prop("disabled", true)
			$('#step5 .nextButton').prop("disabled", true)
			$('#step6 .nextButton').prop("disabled", true)
		}
		$('.emoji.active').removeClass("active")
		$('#art_share button').removeClass("active")
		$('#art_einfluss button').removeClass("active")
		$('#art_freitext_einfluss').val("")
		$('#art_freitext_keinEinfluss').val("")
		$('h5').removeClass("active")
		$("#art_impact").slider('setValue', 3)
		$('#art_message').val("")
		$('#pdfLink').show()
		$('.finalButton').hide()
	})

	$('#artefaktVideo').on('ended',function(){
		$(".section.active .nextButton").prop("disabled", false)
	});

	// Instantiate a slider
	var mySlider = $("input.slider").slider({
		value: 3,
		tooltip: 'hide',
		ticks: [1, 2, 3, 4, 5]
	});

	$( "input.slider" ).on( "change", function( event, ui ) {
		$(this).parent().parent().find(".nextQ").prop("disabled", false)
	} )

	$( "#antwort_einfluss button, #art_einfluss button, #art_wirkung button, #art_share button" ).click(function() {
		$(this).parent().parent().find(".nextQ").prop("disabled", false)
	})

	$( "#pdfLink" ).click(function() {
		$(".finalButton").show()
		$(this).hide()
	})

	$( ".audioContainerOverlay" ).click(function() {
		$(this).removeClass("visible")
		var audioId = $(this).parent().index()
		if (audioId === 1) {
			audio_einleitung1.play()
		}
		if (audioId === 3) {
			audio_einleitung2.play()
		}
		if (audioId === 4) {
			artefaktDetail.play()
		}
		if (audioId === 6) {
			artefaktReise.play()
		}
		if (audioId === 0) {
			audio_vorsatz.play()
		}
		if (audioId === 9) {
			audio_finale.play()
		}
	})
	audio_einleitung1 = new CircularAudioWave(document.getElementById('audio_einleitung1'));
	audio_einleitung1.loadAudio('/assets/audios/00-Einleitung-1.mp3');
});

let user = {
	id: guidGenerator(),
	geschlecht: "keine Angabe",
	alter: "keine Angabe",
	wohnort: "keine Angabe",
	zukunftsAusblick: "",
	zukunftMuenchen: "",
	akteure: {
		unternehmen: 0,
		wissenschaft: 0,
		politik: 0,
		ngos: 0,
		einzelne: 0
	},
	einfluss: "",
	einflussText: ""
}

let artefakt = {
	id: "",
	artefakt_id: "",
	stimmung: "",
	lebenswert: "",
	nutzung: "",
	beeinflussen_wert: "",
	beeinflussen: "",
	beeinflussen_text: "",
	sharing: "",
	sharing_text: "",
	botschaft: ""
}

// Audio Objekte werden initialisiert
let audio_einleitung1 = {}
let audio_einleitung2 = {}
let artefaktDetail = {}
let artefaktReise = {}
let audio_vorsatz = {}
let audio_finale = {}
let video = document.getElementById("artefaktVideo");

function changeSteps(prev, next, aid) {
	$("body").removeClass()
	$("body").addClass('step' + next)
	$("#step" + prev).removeClass("active")
	$("#step" + next).addClass("active")

	// STEP Einleitung
	if( prev === 0 && next === 1 ) {
		if( $(".container").hasClass("noAudio") === false ) {
			audio_einleitung1.play()
			// spätere Audios werden jetzt geladen
			audio_einleitung2 = new CircularAudioWave(document.getElementById('audio_einleitung2'));
			audio_einleitung2.loadAudio('/assets/audios/00-Einleitung-2.mp3');
		}
	}

	if( prev === 3 && next === 0 ) {
		$('.container').removeClass("noAudio")
		if( audio_einleitung2.playing === true ) {
			stopAudio(audio_einleitung2)
		}
		audio_einleitung1 = new CircularAudioWave(document.getElementById('audio_einleitung1'));
		audio_einleitung1.loadAudio('/assets/audios/00-Einleitung-1.mp3');
		audio_einleitung2 = new CircularAudioWave(document.getElementById('audio_einleitung2'));
		audio_einleitung2.loadAudio('/assets/audios/00-Einleitung-2.mp3');
	}

	// STEP Befragung
	if( prev === 1 && next === 2 ) {
		if( $(".container").hasClass("noAudio") === false ) {
			// Kontrolle ob nicht das Audio noch läuft, wenn ja dann wird es angehalten
			if( audio_einleitung1.playing === true ) {
				stopAudio(audio_einleitung1)
			} else {
			}
		}	
	}

	// STEP Artekfakte
	if( prev === 2 && next === 3 ) {
		if( $(".container").hasClass("noAudio") === false ) {
			audio_einleitung2.play()
		}
		sendUserDataToDB()
		console.log(user)
	}

	// STEP Artekfakte Detail
	if( prev === 3 && next === 4 ) {
		if( $(".container").hasClass("noAudio") === false ) {
			$("#loadingContainer").addClass("visible")
			if( audio_einleitung2.playing === true ) {
				stopAudio(audio_einleitung2)
			}
			$("#step4 button").prop("disabled", true)
			artefaktDetail = new CircularAudioWave(document.getElementById('artefaktDetail'));
			artefaktDetail.loadAudio('/assets/audios/artefakt' + aid + '-intro.mp3');
			var windowWidth = $( window ).width()
			var url = ""
			if ( windowWidth >= 860) {
				// $("#step5 video").attr("src", "assets/videos/artefakt" + aid + "_u.mp4")
				url = "assets/videos/artefakt" + aid + ".mp4"
			} else {
				// $("#step5 video").attr("src", "assets/videos/artefakt" + aid + "_mobile_u.mp4")
				url = "assets/videos/artefakt" + aid + "_mobile.mp4"
			}
			// Video wird geladen
			var xhr = new XMLHttpRequest();
			xhr.open("GET", url, true);
			xhr.responseType = "arraybuffer";
			xhr.onload = function(oEvent) {
				var blob = new Blob([oEvent.target.response], {type: "video/mp4"});
				video.src = URL.createObjectURL(blob);
				artefaktDetail.play()
				$("#loadingContainer").removeClass("visible")
				// video.play()  if you want it to play on load
			};
			xhr.onprogress = function(oEvent) {
				if (oEvent.lengthComputable) {
					var percentComplete = oEvent.loaded/oEvent.total;
					var percentText = percentComplete.toString()
					$("#loadingContainer h1 span").text(percentText.slice(2, 4))
				}
			}
			xhr.send();
			artefaktReise = new CircularAudioWave(document.getElementById('artefaktReise'));
			artefaktReise.loadAudio('/assets/audios/artefakt' + aid + '.mp3');
			audio_vorsatz = new CircularAudioWave(document.getElementById('audioContainer_vorsatz'));
			audio_vorsatz.loadAudio('/assets/audios/audioContainer_vorsatz' + aid + '.mp3');
			audio_finale = new CircularAudioWave(document.getElementById('audioContainer_finale'));
			audio_finale.loadAudio('/assets/audios/Ende.mp3');
		} else {
			$("#loadingContainer").addClass("visible")
			$(".artefaktText").hide()
			$("#textContainer_artefakt" + aid).show()
			var windowWidth = $( window ).width()
			var url = ""
			if ( windowWidth >= 860) {
				// $("#step5 video").attr("src", "assets/videos/artefakt" + aid + "_u.mp4")
				url = "assets/videos/artefakt" + aid + "_u.mp4"
			} else {
				// $("#step5 video").attr("src", "assets/videos/artefakt" + aid + "_mobile_u.mp4")
				url = "assets/videos/artefakt" + aid + "_mobile_u.mp4"
			}
			// Video wird geladen
			var xhr = new XMLHttpRequest();
			xhr.open("GET", url, true);
			xhr.responseType = "arraybuffer";
			xhr.onload = function(oEvent) {
				var blob = new Blob([oEvent.target.response], {type: "video/mp4"});
				video.src = URL.createObjectURL(blob);
				$("#loadingContainer").removeClass("visible")
				// video.play()  if you want it to play on load
			};
			xhr.onprogress = function(oEvent) {
				if (oEvent.lengthComputable) {
						var percentComplete = oEvent.loaded/oEvent.total;
						var percentText = percentComplete.toString()
						$("#loadingContainer h1 span").text(percentText.slice(2, 4))
				}
			}
			xhr.send();
		}
	}

	// Step Artefakte Video
	if( prev === 4 && next === 5 ) {
		if( artefaktDetail.playing === true ) {
			artefaktDetail.playing = false;
			artefaktDetail.context.close();
			artefaktDetail.sourceNode.buffer = null;
			artefaktDetail.offlineSource.buffer = null;
			artefaktDetail.reset();
		}
		video.play()
	}

	// Step Artefakte Audio
	if( prev === 5 && next === 6 ) {
		var aid = $(".container").attr('ca')
		video.pause()
		if( $(".container").hasClass("noAudio") === false ) {
			if( artefaktDetail.playing === true ) {
				stopAudio(artefaktDetail)
			}
			artefaktReise.play()
		} else {
			$(".artefaktText").hide()
			$("#textContainer_artefaktReise" + aid).show()
		}
	}

	// Step Artefakte Audio
	if( prev === 6 && next === 7 ) {
		if( $(".container").hasClass("noAudio") === false ) {	
			if( artefaktReise.playing === true ) {
				stopAudio(artefaktReise)
			} else {
			}
		}
	}
	if( prev === 7 && next === 8 ) {
		var aid = $(".container").attr('ca')
		$(".artefaktText").hide()
		$("#textContainer_ueberlegung" + aid).show()
		if( $(".container").hasClass("noAudio") === false ) {	
			audio_vorsatz.play()	
		}
		artefakt['id'] = user['id']
		artefakt['artefakt_id'] = $(".container").attr("ca")
		sendArtefaktDataToDB()
	}
	if( prev === 8 && next === 3 ) {
		if( audio_vorsatz.playing === true ) {
			stopAudio(audio_vorsatz)
		} else {
		}
	}
	if( prev === 9 && next === 3 ) {
		$("#fortschrittsBalken div span").removeClass("active")
		$("#fortschrittsBalken div span").eq(3).addClass("active")
		if( audio_finale.playing === true ) {
			stopAudio(audio_finale)
		} else {
		}
	}
	if( prev === 8 && next === 9 ) {
		if( $(".container").hasClass("noAudio") === false ) {	
			if( audio_vorsatz.playing === true ) {
				stopAudio(audio_vorsatz)
			} else {
			}
			audio_finale.play()
		}
	}
}

function stopAudio(audio) {
	audio.playing = false;
	audio.context.close();
	audio.sourceNode.buffer = null;
	audio.offlineSource.buffer = null;
	audio.reset();
}

function guidGenerator() {
	var S4 = function() {
		 return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
	};
	return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}

function sendUserDataToDB() {
	$.ajax({
		type: 'post',
		url: "php/sendUserDataToDB.php",
		data: JSON.stringify(user),
		contentType: "application/json; charset=utf-8",
		traditional: true,
		success: function success(data) {
      console.log("User Data übermittelt");
    },
    error: function error(e) {
      console.log(e);
    }
	});
}

function sendArtefaktDataToDB() {
	$.ajax({
		type: 'post',
		url: "php/sendArtefaktDataToDB.php",
		data: JSON.stringify(artefakt),
		contentType: "application/json; charset=utf-8",
		traditional: true,
		success: function success(data) {
      console.log("Artefakt Data übermittelt");
    },
    error: function error(e) {
      console.log(e);
    }
	});
}
